import { useLocation } from "react-router-dom";

import AccountSettings from "../../Blocks/Modals/SettingsModal/AccountSettings/AccountSettings";
import SettingsModal from "../../Blocks/Modals/SettingsModal/SettingsModal";
import {
  AccountSettingSectionNames,
  AccountSettingsSectionRoutes,
  enumAccountSettings
} from "../../../providers/NavigationProvider";
import { getCurrentSectionData, getRouteToNextTab } from "../_utils";
import { useAppNavigate } from "@/hooks/useAppNavigate";
import * as StateLib from "@/Utils/StateLib";
import cx from "classnames";
import Header from "@/appComponents/Navigation/Header/Header";
import { appstr } from "@coreapp/utils/appstr";
import { Fragment, useEffect } from "react";
import { CreateBaseChartModal } from "@/appComponents/Blocks/Modals/CreateBaseChartModal/CreateBaseChartModal";
import { useAccountSettingsContext } from "@/providers/AccountSettingsProvider";

const AccountSettingsPage = () => {
  const { accountConfig, LoadAccountMetadata } = useAccountSettingsContext();
  const nav = useAppNavigate();
  const location = useLocation();
  let wsMgr = StateLib.GetWSMgr();

  useEffect(() => {
    if (!accountConfig) LoadAccountMetadata();
  }, []);

  if (!accountConfig) return null;

  const [, , , sectionRoute] = location.pathname.split("/");
  const { sectionKey, tabIndex } = getCurrentSectionData(
    sectionRoute,
    "General",
    AccountSettingsSectionRoutes,
    enumAccountSettings
  );

  const handleChangeCurrentTab = nextTab => {
    const route = getRouteToNextTab(nextTab, enumAccountSettings, AccountSettingsSectionRoutes);
    nav.navigateSettings("account", route, { replace: true });
    wsMgr.UpdateDocTitle();
  };

  return (
    <>
      <div className={cx("appHeader--modal")}>
        <Header customToolbarClass={"oc-settings-toolbar"} />
        <SettingsModal
          title={appstr("Account Settings")}
          subtitle={appstr(AccountSettingSectionNames[sectionKey])}
        >
          {({ onCloseModal }) => (
            <Fragment>
              <AccountSettings
                currentTab={tabIndex}
                setCurrentTab={handleChangeCurrentTab}
                onCloseModal={onCloseModal}
              />
              <CreateBaseChartModal />
            </Fragment>
          )}
        </SettingsModal>
      </div>
    </>
  );
};

export default AccountSettingsPage;
